import React, { useCallback, useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Checkbox, Grid, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton.js";
import Helpers from "../../helpers/helpers";
import { deleteCustomer, exportCustomer, getCustomer, resetCustomerAttachmentState, resetCustomerState } from "../../store/actions";
import CustomerFilterContent from "./CustomerFilterContent";
import DeleteModal from "../../components/Common/DeleteModal.js";


const Customers = ({ delCustArry, exportExcel, customerListing, userPermission }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [page, setPage] = useState("1");
  const [length, setLength] = useState("50");
  const [keyword, setSearch] = useState("");
  const [sort, setSorted] = useState("desc")
  const [sort_by, setSortBy] = useState("id")
  const [status, setStatus] = useState("all");
  const [open, SetOpen] = useState(false);
  const [checkedAll, setCheckedAll] = useState(false);
  const [filterObject, setFilterObject] = useState({});
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [creatable, setCreatable] = useState(false);
  const [editable, setEditable] = useState(false);
  const [deletable, setDeletable] = useState(false);
  const [exportable, setExportable] = useState(false);
  const searchRef = useRef(keyword);

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-customer") && setCreatable(true);
      userPermission?.includes("edit-customer") && setEditable(true);
      userPermission?.includes("delete-customer") && setDeletable(true);
      userPermission?.includes("export-customer") && setExportable(true);
      !userPermission?.includes("view-customer") && navigate('/not-authorized');
    }
  }, [userPermission])

  const [content, setContent] = useState({
    open: false,
    title: "",
    msg: "",
    buttonTitle: "",
    action: "",
    id: "",
  })

  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });

  const getLengthPage = (page, length) => {
    setPage(page)
    setLength(length)
  }

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, page, length, sort, sort_by]);

  useEffect(() => {
    if (delCustArry?.code === "success") {
      setNotification({
        open: true,
        msg: "Delete Successfully",
        type: "success",
      });
      setDeleteOpen(false);
      dispatch(resetCustomerState());
      initData();
    }
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delCustArry]);

  useEffect(() => {
    searchRef.current = keyword || '';
  }, [keyword]);

  const resetFilter = () => {
    setPage("1");
    setSearch('');
    searchRef.current = '';
    setStatus(status === '' ? 'all' : '');
  }

  const delCust = () => {
    if (selectedRow?.id) {
      dispatch(deleteCustomer({ id: selectedRow.id }));
      setIsLoading(true);
    }
  }

  useEffect(() => {
    if (exportExcel?.code === "success") {
      setIsLoading(false)
      Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, 'Customer');
      dispatch(resetCustomerAttachmentState());
    }

  }, [exportExcel]);

  const initData = () => {
    dispatch(getCustomer({ length, page, keyword: searchRef.current, status, sort, sort_by }));
  }

  const header = [
    {
      Header: "Name",
      columnID: "id",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center">
              <div style={{ paddingRight: "5px" }}>{cellProps.name}</div>
              {cellProps?.customer_group_id === 2 && <i className="ri-vip-crown-fill" style={{ color: '#FFCC00', fontSize: 16 }} />}
            </div>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Status",
      columnID: "status",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Stack flexDirection={"column"}>
              <Label.StatusLabel label={cellProps?.status === 1 ? "Active" : "Inactive"} marginLeft={"0px"} />
            </Stack>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Address",
      accessor: (cellProps) => {
        return (
          <div>
            <div>{cellProps?.shipping_address?.address_line_1 ? cellProps?.shipping_address?.address_line_1 + "," : ""} {cellProps?.shipping_address?.address_line_2 ? cellProps?.shipping_address?.address_line_2 + "," : ""}</div>
            <div>{cellProps?.shipping_address?.city ? cellProps?.shipping_address?.city + "," : ""} {cellProps?.shipping_address?.state ? cellProps?.shipping_address?.state + "," : ""} {cellProps?.shipping_address?.country ? cellProps?.shipping_address?.country + "." : "-"}</div>
          </div>

        )
      },
      columnID: "address",
      minWidth: 150,
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Total orders",
      columnID: "orders_count",
      accessor: (cellProps) => {
        return (
          <div>{cellProps?.orders_count || '0'} order{`${cellProps?.orders_count > 1 ? 's' : ''}`}</div>
        )
      },
      minWidth: 100,
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Amount spend (S$)",
      columnID: "orders_sum_order_amount",
      accessor: (cellProps) => {
        return (
          <div style={{ display: "flex" }}>S${cellProps?.orders_sum_order_amount || '0.00'}</div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Action",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {editable && <Link to={`/edit-customer/` + (cellProps.id)}>
              <CustomIconButton iconName={'ri-pencil-line'} onClick={() => ''} />
            </Link>}
            {deletable &&
              <RenderPopOverButton
                items={[{
                  iconName: 'ri-delete-bin-line',
                  label: 'Delete',
                  color: '#44d62c',
                  permission: deletable,
                  onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
                }]} />
            }</React.Fragment>
        )
      },
      minWidth: 120,
      position: 'sticky',
      disableFilters: true,
      filterable: false,
    }
  ]

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        setPage("1");
        initData();
      }
    }, Helpers.searchInterval);
  }

  const handleExportCustomerListing = () => {
    let filter = {
      status: status,
      search: keyword
    }
    Object.keys(filter).forEach(key => {
      if (!filter[key] || filter[key] === 'all') {
        delete filter[key];
      }
    });
    dispatch(exportCustomer({
      sort: sort_by,
      sort_order: sort,
      filter: filter
    }));
    setIsLoading(true)
  }

  const customToolsBar = () => {
    return (
      <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
        <Grid container item lg={10} xs={12} spacing={1} className="d-flex align-items-center">
          <Grid item lg={3} md={3} xs={12}>
            <SearchBar
              value={keyword}
              setValue={(e) => handleSearch(e)}
            />
          </Grid>
          <Grid item lg={3} md={3} xs={12}>
            <CustomSelect2 values={status || 'all'} onChange={(e) => { setPage("1"); setStatus(e) }} data={Helpers.status} />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <CustomButton
              title={'Clear'}
              press={() => resetFilter()}
              height={32}
              backgroundColor={'transparent'}
              textColor={'#7BB9FA'}
            />
          </Grid>

        </Grid>
        {exportable && <Grid item lg={2} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
          <CustomButton
            title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
            press={() => handleExportCustomerListing()}
            height={32}
            borderRadius={15}
            borderStyle={"1px solid #babcbe"}
          />
        </Grid>}
      </Grid>
    )
  }

  const renderHeader = () => {
    return (
      <Grid container className="d-flex justify-content-between align-items-center p-1 pb-2">
        <Grid item lg={10} md={9} xs={12} className="header">
          Customers
        </Grid>
        {
          creatable &&
          <Grid item lg={2} md={3} xs={12} sx={{ marginTop: { lg: 0, xs: 1 }, display: 'flex', justifyContent: { lg: 'end', md: 'end', xs: 'start' } }} >
            <CustomButton
              title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add New Customers </>}
              borderStyle={'1px solid #101010'}
              backgroundColor={'#101010'}
              textColor={'white'}
              // width={'100%'}
              press={() => navigate('/add-customer')}
            />
          </Grid>
        }
      </Grid>
    )
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <LoadingDialog open={loading || !customerListing?.data} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          {renderHeader()}
          {customToolsBar()}
          <Table
            header={header}
            data={customerListing?.data?.data || []}
            pageSize={length}
            totalPage={customerListing?.last_page}
            getLengthPage={getLengthPage}
            customToolsBar={true}
            setCheckedAll={setCheckedAll}
            setSorted={setSorted}
            sort_by={sort_by}
            setSortBy={setSortBy}
            checkedAll={checkedAll}
            sort={sort}
          />
          <TablePageControl
            length={length}
            setLength={setLength}
            page={page}
            setPage={setPage}
            totalPage={customerListing?.data?.last_page}
          />
          <CustomerFilterContent
            open={open}
            close={() => SetOpen(false)}
            formValue={filterObject}
            onChange={setFilterObject}
            raceList={[]}
          />
        </Container>
        <DeleteModal
          open={deleteOpen}
          close={() => setDeleteOpen(false)}
          submit={() => delCust()}
          module={'customer'}
        />
      </div>
    </React.Fragment>
  );
};

function mapStateToProps({ Customer, Login }) {
  return {
    customerListing: Customer.customer,
    delCustomer: Customer.delCustomer,
    userData: Login?.verifyAdmin?.user?.data,
    delCustArry: Customer?.delCustomer,
    exportExcel: Customer.exportCustomer,
    userPermission: Login.permissionArry,

  };
}


export default connect(mapStateToProps)(Customers);
